define([], () => {

  const blockTypes = {
    DEFAULT_NODE: 'paragraph',
    HEADING_1_NODE: 'heading-1',
    HEADING_2_NODE: 'heading-2',
    HEADING_3_NODE: 'heading-3',
    HEADING_4_NODE: 'heading-4',
    HEADING_5_NODE: 'heading-5',
    HEADING_6_NODE: 'heading-6',
    BLOCKQUOTE_NODE: 'block-quote',
    BLOCKCODE_NODE: 'block-code',
    BULLETED_LIST_NODE: 'bulleted-list',
    NUMBERED_LIST_NODE: 'numbered-list',
    LIST_ITEM_NODE: 'list-item',
    LINE_NODE: 'horizontal-rule',
    TABLE_NODE: 'table',
    TABLE_HEAD_NODE: 'table-head',
    TABLE_ROW_NODE: 'table-row',
    TABLE_CELL_NODE: 'table-cell',
    PRODUCT_NODE: 'product',
  };

  const inlineTypes = {
    LINK_NODE: 'link',
    IMAGE_NODE: 'image',
    BUTTON_NODE: 'button',
  };

  const markTypes = {
    BOLD_MARK: 'bold',
    ITALIC_MARK: 'italic',
    UNDERLINE_MARK: 'underlined',
    STRIKETHROUGH_MARK: 'strikethrough',
    HIGHLIGHT_MARK: 'highlight',
    CODE_MARK: 'code',
    SUBSCRIPT_MARK: 'subscript',
    SUPERSCRIPT_MARK: 'superscript',
    CENTER_MARK: 'center',
    SPAN_MARK: 'span',
    FONT_FAMILY_MARK: 'font-family',
    FONT_COLOR_MARK: 'font-color',
  };

  const blankValue = {
    document: {
      nodes: [
        {
          object: 'block',
          type: 'paragraph',
          nodes: [
            {
              object: 'text',
              leaves: [
                {
                  text: ''
                }
              ]
            }
          ]
        }
      ]
    }
  };

  const blockTags = {
    p: blockTypes.DEFAULT_NODE,
    li: blockTypes.LIST_ITEM_NODE,
    ul: blockTypes.BULLETED_LIST_NODE,
    ol: blockTypes.NUMBERED_LIST_NODE,
    blockquote: blockTypes.BLOCKCODE_NODE,
    pre: blockTypes.BLOCKCODE_NODE,
    h1: blockTypes.HEADING_1_NODE,
    h2: blockTypes.HEADING_2_NODE,
    h3: blockTypes.HEADING_3_NODE,
    h4: blockTypes.HEADING_4_NODE,
    h5: blockTypes.HEADING_5_NODE,
    h6: blockTypes.HEADING_6_NODE,
  };

  const inlineTags = {
    a: inlineTypes.LINK_NODE,
    img: inlineTypes.IMAGE_NODE,
    button: inlineTypes.BUTTON_NODE,
  };

  const markTags = {
    strong: markTypes.BOLD_MARK,
    b: markTypes.BOLD_MARK,
    em: markTypes.ITALIC_MARK,
    i: markTypes.ITALIC_MARK,
    u: markTypes.UNDERLINE_MARK,
    s: markTypes.STRIKETHROUGH_MARK,
    code: markTypes.CODE_MARK,
    span: markTypes.SPAN_MARK,
  };

  const fontFamilies = [
    'Sans Serif',
    'Serif',
    'Georgia',
    'Monospace',
    'Tahoma',
    'Verdana',
  ];

  const textColors = [
    { value: 'rgb(0, 0, 0)' },
    { value: 'rgb(68, 68, 68)' },
    { value: 'rgb(102, 102, 102)' },
    { value: 'rgb(153, 153, 153)' },
    { value: 'rgb(204, 204, 204)' },
    { value: 'rgb(238, 238, 238)' },
    { value: 'rgb(243, 243, 243)' },
    { value: 'rgb(255, 255, 255)' },

    { value: 'rgb(255, 0, 0)' },
    { value: 'rgb(255, 153, 0)' },
    { value: 'rgb(255, 255, 0)' },
    { value: 'rgb(0, 255, 0)' },
    { value: 'rgb(0, 255, 255)' },
    { value: 'rgb(0, 0, 255)' },
    { value: 'rgb(153, 0, 255)' },
    { value: 'rgb(255, 0, 255)' },

    { value: 'rgb(244, 204, 204)' },
    { value: 'rgb(252, 229, 205)' },
    { value: 'rgb(255, 242, 204)' },
    { value: 'rgb(217, 234, 211)' },
    { value: 'rgb(208, 224, 227)' },
    { value: 'rgb(207, 226, 243)' },
    { value: 'rgb(217, 210, 233)' },
    { value: 'rgb(234, 209, 220)' },

    { value: 'rgb(234, 153, 153)' },
    { value: 'rgb(249, 203, 156)' },
    { value: 'rgb(255, 229, 153)' },
    { value: 'rgb(182, 215, 168)' },
    { value: 'rgb(162, 196, 201)' },
    { value: 'rgb(159, 197, 232)' },
    { value: 'rgb(180, 167, 214)' },
    { value: 'rgb(213, 166, 189)' },

    { value: 'rgb(224, 102, 102)' },
    { value: 'rgb(246, 178, 107)' },
    { value: 'rgb(255, 217, 102)' },
    { value: 'rgb(147, 196, 125)' },
    { value: 'rgb(118, 165, 175)' },
    { value: 'rgb(111, 168, 220)' },
    { value: 'rgb(142, 124, 195)' },
    { value: 'rgb(194, 123, 160)' },

    { value: 'rgb(204, 0, 0)' },
    { value: 'rgb(230, 145, 56)' },
    { value: 'rgb(241, 194, 50)' },
    { value: 'rgb(106, 168, 79)' },
    { value: 'rgb(69, 129, 142)' },
    { value: 'rgb(61, 133, 198)' },
    { value: 'rgb(103, 78, 167)' },
    { value: 'rgb(166, 77, 121)' },

    { value: 'rgb(153, 0, 0)' },
    { value: 'rgb(180, 95, 6)' },
    { value: 'rgb(191, 144, 0)' },
    { value: 'rgb(56, 118, 29)' },
    { value: 'rgb(19, 79, 92)' },
    { value: 'rgb(11, 83, 148)' },
    { value: 'rgb(53, 28, 117)' },
    { value: 'rgb(116, 27, 71)' },

    { value: 'rgb(102, 0, 0)' },
    { value: 'rgb(120, 63, 4)' },
    { value: 'rgb(127, 96, 0)' },
    { value: 'rgb(39, 78, 19)' },
    { value: 'rgb(12, 52, 61)' },
    { value: 'rgb(7, 55, 99)' },
    { value: 'rgb(32, 18, 77)' },
    { value: 'rgb(76, 17, 48)' },
  ];

  return {
    blankValue,
    blockTypes,
    blockTags,
    fontFamilies,
    inlineTags,
    inlineTypes,
    markTags,
    markTypes,
    textColors,
  };
});
